import { render, staticRenderFns } from "./ModalCadastrarBeneficiario.vue?vue&type=template&id=26cad413&scoped=true"
import script from "./ModalCadastrarBeneficiario.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastrarBeneficiario.vue?vue&type=style&index=0&id=26cad413&prod&lang=css"
import style1 from "./ModalCadastrarBeneficiario.vue?vue&type=style&index=1&id=26cad413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cad413",
  null
  
)

export default component.exports